module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f79f6ef06011c5d3bd83befa3e605a78.png";